"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFieldOperator = void 0;
let CustomFieldOperator = exports.CustomFieldOperator = /*#__PURE__*/function (CustomFieldOperator) {
  CustomFieldOperator["Equals"] = "eq";
  CustomFieldOperator["NotEquals"] = "ne";
  CustomFieldOperator["GreaterThan"] = "gt";
  CustomFieldOperator["GreaterThanOrEqual"] = "gte";
  CustomFieldOperator["LessThan"] = "lt";
  CustomFieldOperator["LessThanOrEqual"] = "lte";
  CustomFieldOperator["Contains"] = "co";
  CustomFieldOperator["NotContains"] = "nc";
  return CustomFieldOperator;
}({});
//# sourceMappingURL=types.js.map